import { render, staticRenderFns } from "./TargetingInactivity.vue?vue&type=template&id=51bd7a01&"
import script from "./TargetingInactivity.vue?vue&type=script&lang=js&"
export * from "./TargetingInactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports